import { FieldErrors } from 'react-hook-form';
import { WebhookFormValues } from '../types';

type FlattenedErrors = {
    name: string;
    message: string;
}[];

export const getFlattenedErrors = (errors: FieldErrors<WebhookFormValues>): FlattenedErrors => {
    const flattened: FlattenedErrors = [];

    const traverseErrors = (currentErrors: FieldErrors<WebhookFormValues>, path: string[]) => {
        const errorsAsRecord = currentErrors as Partial<Record<string, any>>;
        for (const key in errorsAsRecord) {
            if (errorsAsRecord.hasOwnProperty(key)) {
                const error = errorsAsRecord[key];
                const currentPath = [...path, key];

                if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
                    flattened.push({ name: currentPath.join('.'), message: error.message });
                } else if (error && typeof error === 'object') {
                    traverseErrors(error as FieldErrors<WebhookFormValues>, currentPath);
                }
            }
        }
    };

    traverseErrors(errors, []);
    return flattened;
};
